import React from 'react'
import './style.min.css'

const Tabs = ({
  links, width, height, active, onClickHandler
}) => {
  let activeLink = parseInt(active)
  let isActive // Initially it's a number, converting to number incase is string

  return (
  <nav className="Tab" style={{ width: width, height: height}}>
    {
      links.map((link, i) => {
        activeLink-1 === i ? isActive = 'active' : isActive = 'not-active'
        return <Link
          key={i} link={link} 
          isActive={isActive} number={i + 1}
          onClickHandler={onClickHandler}
        />
      })
    }
  </nav>
)}

const Link = ({ number, link, isActive, onClickHandler }) => (
  <button className={`TabButton ${isActive}`} onClick={onClickHandler.bind(null, number)}>
    {link}
  </button>
)

export default Tabs